var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _vm.loadingSpinner
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-center" },
            [
              _c("b-spinner", {
                staticStyle: { width: "3rem", height: "3rem" },
                attrs: { variant: "success", label: "Spinning" },
              }),
            ],
            1
          )
        : _vm._e(),
      !_vm.loadingSpinner
        ? _c(
            "b-row",
            [
              _c("b-col", { staticClass: "mt-1", attrs: { cols: "12" } }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex flex-wrap justify-content-center d-md-flex d-lg-none",
                  },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "my-1 w-100 d-block d-md-none",
                        staticStyle: {
                          "background-color": "transparent !important",
                          color: "#93bb3d !important",
                          "font-weight": "bold !important",
                        },
                        attrs: { disabled: "", variant: "primary" },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s("Not Started = ") +
                            " " +
                            _vm._s(this.notStarted) +
                            " "
                        ),
                      ]
                    ),
                    _c(
                      "b-button",
                      {
                        staticClass: "my-1 w-100 d-block d-md-none",
                        staticStyle: {
                          "background-color": "transparent !important",
                          color: "#93bb3d !important",
                          "font-weight": "bold !important",
                        },
                        attrs: { disabled: "", variant: "primary" },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s("Started = ") +
                            " " +
                            _vm._s(this.started) +
                            " "
                        ),
                      ]
                    ),
                    _c(
                      "b-button",
                      {
                        staticClass: "my-1 w-100 d-block d-md-none",
                        staticStyle: {
                          "background-color": "transparent !important",
                          color: "#93bb3d !important",
                          "font-weight": "bold !important",
                        },
                        attrs: { disabled: "", variant: "primary" },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s("Completed = ") +
                            " " +
                            _vm._s(this.completed) +
                            " "
                        ),
                      ]
                    ),
                    _c(
                      "b-button",
                      {
                        staticClass: "my-1 w-100 d-block d-md-none",
                        staticStyle: {
                          "background-color": "transparent !important",
                          color: "#93bb3d !important",
                          "font-weight": "bold !important",
                        },
                        attrs: { disabled: "", variant: "primary" },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s("Cancelled = ") +
                            " " +
                            _vm._s(this.cancelled) +
                            " "
                        ),
                      ]
                    ),
                    _c(
                      "b-button",
                      {
                        staticClass: "my-1 w-100 d-block d-md-none",
                        staticStyle: {
                          "background-color": "transparent !important",
                          color: "#93bb3d !important",
                          "font-weight": "bold !important",
                        },
                        attrs: { disabled: "", variant: "primary" },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s("Blocked = ") +
                            " " +
                            _vm._s(this.blocked) +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "d-none d-lg-flex flex-wrap justify-content-center",
                  },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "my-1 mx-1",
                        staticStyle: {
                          "background-color": "transparent !important",
                          color: "#93bb3d !important",
                          "font-weight": "bold !important",
                        },
                        attrs: { disabled: "", variant: "primary" },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s("Not Started = ") +
                            " " +
                            _vm._s(this.notStarted) +
                            " "
                        ),
                      ]
                    ),
                    _c(
                      "b-button",
                      {
                        staticClass: "my-1 mx-1",
                        staticStyle: {
                          "background-color": "transparent !important",
                          color: "#93bb3d !important",
                          "font-weight": "bold !important",
                        },
                        attrs: { disabled: "", variant: "primary" },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s("Started = ") +
                            " " +
                            _vm._s(this.started) +
                            " "
                        ),
                      ]
                    ),
                    _c(
                      "b-button",
                      {
                        staticClass: "my-1 mx-1",
                        staticStyle: {
                          "background-color": "transparent !important",
                          color: "#93bb3d !important",
                          "font-weight": "bold !important",
                        },
                        attrs: { disabled: "", variant: "primary" },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s("Completed = ") +
                            " " +
                            _vm._s(this.completed) +
                            " "
                        ),
                      ]
                    ),
                    _c(
                      "b-button",
                      {
                        staticClass: "my-1 mx-1",
                        staticStyle: {
                          "background-color": "transparent !important",
                          color: "#93bb3d !important",
                          "font-weight": "bold !important",
                        },
                        attrs: { disabled: "", variant: "primary" },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s("Cancelled = ") +
                            " " +
                            _vm._s(this.cancelled) +
                            " "
                        ),
                      ]
                    ),
                    _c(
                      "b-button",
                      {
                        staticClass: "my-1 mx-1",
                        staticStyle: {
                          "background-color": "transparent !important",
                          color: "#93bb3d !important",
                          "font-weight": "bold !important",
                        },
                        attrs: { disabled: "", variant: "primary" },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s("Blocked = ") +
                            " " +
                            _vm._s(this.blocked) +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "d-flex justify-content-end" },
                  [
                    _c(
                      "b-button",
                      {
                        directives: [
                          {
                            name: "b-modal",
                            rawName: "v-b-modal.modal-addcategory",
                            modifiers: { "modal-addcategory": true },
                          },
                        ],
                        staticClass: "my-1",
                        attrs: { variant: "primary", to: "/jobcard/add" },
                      },
                      [_vm._v(" Process Orders ")]
                    ),
                  ],
                  1
                ),
              ]),
              _c(
                "b-col",
                {
                  staticClass: "my-1",
                  attrs: { cols: "12", md: "2", sm: "2" },
                },
                [
                  _c(
                    "b-form-group",
                    { staticClass: "mb-0" },
                    [
                      _c(
                        "label",
                        { staticClass: "d-inline-block text-sm-left mr-50" },
                        [_vm._v("Per page")]
                      ),
                      _c("b-form-select", {
                        attrs: {
                          id: "perPageSelect",
                          size: "sm",
                          options: _vm.pageOptions,
                        },
                        model: {
                          value: _vm.perPage,
                          callback: function ($$v) {
                            _vm.perPage = $$v
                          },
                          expression: "perPage",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                {
                  staticClass: "d-flex justify-content-end mb-2",
                  staticStyle: { position: "relative", "z-index": "1" },
                  attrs: { cols: "12" },
                },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "outline-danger" },
                      on: { click: _vm.clearFilters },
                    },
                    [_vm._v(" Clear Filters ")]
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("b-table", {
                    attrs: {
                      striped: "",
                      hover: "",
                      responsive: "",
                      "per-page": _vm.perPage,
                      "current-page": _vm.currentPage,
                      items: _vm.filteredJobcards,
                      fields: _vm.fields,
                      "sort-by": _vm.sortBy,
                      "sort-desc": _vm.sortDesc,
                      "sort-direction": _vm.sortDirection,
                    },
                    on: {
                      "update:sortBy": function ($event) {
                        _vm.sortBy = $event
                      },
                      "update:sort-by": function ($event) {
                        _vm.sortBy = $event
                      },
                      "update:sortDesc": function ($event) {
                        _vm.sortDesc = $event
                      },
                      "update:sort-desc": function ($event) {
                        _vm.sortDesc = $event
                      },
                      filtered: _vm.onFiltered,
                      "row-clicked": _vm.onRowClicked,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "head(name)",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "d-flex flex-column" },
                                [
                                  _c("span", [_vm._v("Job Card Name")]),
                                  _c("b-form-input", {
                                    attrs: {
                                      placeholder: "Search Job Card Name",
                                      size: "sm",
                                    },
                                    on: {
                                      input: function ($event) {
                                        _vm.currentPage = 1
                                      },
                                    },
                                    model: {
                                      value: _vm.filters.name,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.filters, "name", $$v)
                                      },
                                      expression: "filters.name",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: "head(startDate)",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "d-flex flex-column" },
                                [
                                  _c("span", [_vm._v("Start Date")]),
                                  _c("DatePicker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      format: "YYYY-MM-DD",
                                      placeholder: "Select Start Date",
                                      size: "sm",
                                    },
                                    on: {
                                      change: function ($event) {
                                        _vm.currentPage = 1
                                      },
                                    },
                                    model: {
                                      value: _vm.filters.startDate,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.filters, "startDate", $$v)
                                      },
                                      expression: "filters.startDate",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: "head(endDate)",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "d-flex flex-column" },
                                [
                                  _c("span", [_vm._v("End Date")]),
                                  _c("DatePicker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      format: "YYYY-MM-DD",
                                      placeholder: "Select End Date",
                                      size: "sm",
                                    },
                                    on: {
                                      change: function ($event) {
                                        _vm.currentPage = 1
                                      },
                                    },
                                    model: {
                                      value: _vm.filters.endDate,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.filters, "endDate", $$v)
                                      },
                                      expression: "filters.endDate",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: "head(status)",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "d-flex flex-column" },
                                [
                                  _c("span", [_vm._v("Status")]),
                                  _c("b-form-select", {
                                    attrs: {
                                      options: _vm.statusOptions,
                                      placeholder: "Select Status",
                                      size: "sm",
                                    },
                                    on: {
                                      input: function ($event) {
                                        _vm.currentPage = 1
                                      },
                                    },
                                    model: {
                                      value: _vm.filters.status,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.filters, "status", $$v)
                                      },
                                      expression: "filters.status",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: "head(priority)",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "d-flex flex-column" },
                                [
                                  _c("span", [_vm._v("Priority")]),
                                  _c("b-form-select", {
                                    attrs: {
                                      options: _vm.priorityOptions,
                                      placeholder: "Select Priority",
                                      size: "sm",
                                    },
                                    on: {
                                      input: function ($event) {
                                        _vm.currentPage = 1
                                      },
                                    },
                                    model: {
                                      value: _vm.filters.priority,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.filters, "priority", $$v)
                                      },
                                      expression: "filters.priority",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: "cell(name)",
                          fn: function (data) {
                            return [
                              _c(
                                "b-link",
                                {
                                  attrs: {
                                    variant: "primary",
                                    to: _vm.getId(data.item.id),
                                  },
                                },
                                [_vm._v(" " + _vm._s(data.item.name) + " ")]
                              ),
                            ]
                          },
                        },
                        {
                          key: "cell(startDate)",
                          fn: function (data) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.dayjs(data.value).format("DD/MM/YYYY")
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                        {
                          key: "cell(endDate)",
                          fn: function (data) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.dayjs(data.value).format("DD/MM/YYYY")
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                        {
                          key: "cell(status)",
                          fn: function (data) {
                            return [
                              data.item.status === 0
                                ? _c(
                                    "b-badge",
                                    { attrs: { variant: "info" } },
                                    [_c("span", [_vm._v("Not Started")])]
                                  )
                                : data.item.status === 1
                                ? _c(
                                    "b-badge",
                                    { attrs: { variant: "secondary" } },
                                    [_c("span", [_vm._v("Started")])]
                                  )
                                : data.item.status === 2
                                ? _c(
                                    "b-badge",
                                    { attrs: { variant: "primary" } },
                                    [_c("span", [_vm._v("Completed")])]
                                  )
                                : data.item.status === 3
                                ? _c(
                                    "b-badge",
                                    { attrs: { variant: "danger" } },
                                    [_c("span", [_vm._v("Cancelled")])]
                                  )
                                : data.item.status === 4
                                ? _c(
                                    "b-badge",
                                    { attrs: { variant: "warning" } },
                                    [_c("span", [_vm._v("Blocked")])]
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                        {
                          key: "cell(complete)",
                          fn: function (data) {
                            return [
                              data.item.status == 1 ||
                              data.item.status == 3 ||
                              data.item.status == 4
                                ? _c("b-form-checkbox", {
                                    attrs: {
                                      checked: _vm.isChecked(data.item.id),
                                      disabled: _vm.isDisabled(
                                        data.item.status
                                      ),
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.checkboxChanged(
                                          data.item.id,
                                          $event
                                        )
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1330328484
                    ),
                  }),
                  _c("div", { staticClass: "d-flex justify-content-end" }),
                  _vm.error
                    ? _c(
                        "b-alert",
                        {
                          staticClass: "d-flex justify-content-center",
                          attrs: { variant: "danger", show: "" },
                        },
                        [
                          _c("h4", { staticClass: "alert-heading" }, [
                            _vm._v(_vm._s(_vm.errorMessage)),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  !_vm.jobCardLoading &&
                  _vm.jobcardList.length === 0 &&
                  !_vm.error
                    ? _c(
                        "b-alert",
                        {
                          staticClass: "d-flex justify-content-center",
                          attrs: { variant: "info", show: "" },
                        },
                        [
                          _c("h4", { staticClass: "alert-heading" }, [
                            _vm._v("No jobcards Yet"),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-content-center mb-1" },
                    [
                      _vm.jobCardLoading && !_vm.error
                        ? _c("b-spinner", {
                            staticStyle: { width: "3rem", height: "3rem" },
                            attrs: {
                              variant: "success",
                              label: "Spinning",
                              block: "",
                              show: "",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("b-pagination", {
                    staticClass: "my-0",
                    attrs: {
                      "total-rows": _vm.filteredJobcards.length,
                      "per-page": _vm.perPage,
                      align: "center",
                      size: "sm",
                    },
                    model: {
                      value: _vm.currentPage,
                      callback: function ($$v) {
                        _vm.currentPage = $$v
                      },
                      expression: "currentPage",
                    },
                  }),
                  _c("b-form-group", [
                    _vm._v(
                      " Showing " +
                        _vm._s(
                          _vm.totalRows > 0
                            ? _vm.perPage * (_vm.currentPage - 1) + 1
                            : 0
                        ) +
                        " to " +
                        _vm._s(
                          _vm.totalRows > 0
                            ? Math.min(
                                _vm.perPage * _vm.currentPage,
                                _vm.totalRows
                              )
                            : 0
                        ) +
                        " of " +
                        _vm._s(_vm.totalRows > 0 ? _vm.totalRows : 0) +
                        " entries "
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }